import type { ForeignEntityId } from "../handles/foreignEntityId";

export interface Label {
  readonly facadeId: ForeignEntityId<"FACADE">;
}

// highest precedence wins when assigning facades to halfEdges
export const LabelPrecedence = {
  Room: 10,
  GableEnd: 5,
};
